import styled, { css } from "styled-components"
import PropTypes from "prop-types"
import { mb, mt } from "styled-components-spacing"
import { Button, ButtonAnchor, ButtonLink } from "./atoms/Buttons"
import { P } from "./atoms/Elements"

export const Lede = styled(P)`
  font-size: 20px;
  line-height: 24px;
`

Lede.propTypes = {}

export const HR = styled.hr`
  border: 0;
  height: ${props => props.height + "px"};
  margin: 0;
  ${props => props.mt !== undefined && mt(props.mt)}
  ${props => props.mb !== undefined && mb(props.mb)}
  ${props =>
    props.color
      ? `background-color: ${props.theme.colors[props.color]};`
      : `background-color: ${props.theme.colors.lightGrey}`}
`

HR.propTypes = {
  color: PropTypes.string,
  mb: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  mt: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  height: PropTypes.number,
}

HR.defaultProps = { height: 1 }

export const Typography = styled.div`
  font-size: 18px;
  line-height: 1.3;
  font-family: ${props => props.theme.fontStacks.sans};
  color: ${props =>
    props.theme.colors[props.textColor] || props.theme.colors.black};

  ${props =>
    props.centered &&
    css`
      text-align: center;
    `}

  // a:not(${ButtonLink}):not(${Button}):not(${ButtonAnchor}) {
  //   color: ${({ theme }) => theme.colors.coral};
  // }

  p {
    margin: 0 0 16px 0;
  }

  small {
    font-size: 16px;
  }
`

Typography.propTypes = {
  centered: PropTypes.bool,
  textColor: PropTypes.string,
}
